import { defineStore } from 'pinia'
import { v4 as uuidv4 } from 'uuid'

const usePersistStore = defineStore('persist', {
  state: () => ({
    // 错题练习
    mistakeExerciseCollapseMap: {},
    deviceSymbol: ''
  }),
  actions: {
    initDeviceSymbol() {
      if(this.deviceSymbol) {
        return
      }
      this.deviceSymbol = uuidv4()
    }
  },
  persist: true,
})

export default usePersistStore